import { Box, Card, HStack, Heading, Text, VStack } from "@chakra-ui/react"
import type { TimeBucket } from "../../../client"

interface TimeDistributionChartProps {
  data: TimeBucket[]
}

export default function TimeDistributionChart({
  data,
}: TimeDistributionChartProps) {
  if (data.length === 0) {
    return (
      <Card.Root h="full">
        <Card.Body>
          <Heading size="md" mb={4}>
            Time Distribution
          </Heading>
          <Text color="gray.500">No data available</Text>
        </Card.Body>
      </Card.Root>
    )
  }

  const maxPercentage = Math.max(...data.map((d) => d.percentage), 10)

  return (
    <Card.Root h="full">
      <Card.Body>
        <Heading size="md" mb={4}>
          Time Distribution
        </Heading>
        <Text fontSize="sm" color="gray.600" mb={4}>
          How long students spend on this question
        </Text>

        <HStack align="end" justify="space-around" h="200px" gap={2}>
          {data.map((bucket, idx) => (
            <VStack key={idx} h="full" justify="end" flex={1} minW="0">
              <Text fontSize="xs" fontWeight="bold" color="blue.600">
                {bucket.percentage.toFixed(0)}%
              </Text>
              <Box
                bg="blue.400"
                w="full"
                h={`${(bucket.percentage / maxPercentage) * 100}%`}
                minH="4px"
                borderRadius="sm"
                transition="height 0.3s"
              />
              <Text
                fontSize="xs"
                color="gray.600"
                textAlign="center"
                wordBreak="break-word"
                lineHeight="1.2"
              >
                {bucket.bucket_label}
              </Text>
            </VStack>
          ))}
        </HStack>
      </Card.Body>
    </Card.Root>
  )
}
